import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { LinkExpirationSetting, LinkExpirationSettingPayload } from 'modules/domains/links';
import { BaseOption } from 'ui/selects';
import { linksArrayName } from './constants';

/** Modals */
export enum ModalAction {
  COPY_ALL = 'copyAll',
  UNSAVED_CHANGES = 'unsavedChanges',
}

export type ModalState = {
  action: ModalAction;
  payload?: {
    setting?: LinkExpirationSetting;
  };
};

/** Search Params */
export interface SearchParamsContextState {
  debouncedSearch: string;
  handleSort: (name: string) => void;
  search: string;
  setSearch: (val: string) => void;
  sortBy: string;
  sortDirection: SORT_DIRECTIONS;
}

export type DataQueryContextState = {
  effectiveDateOptions: BaseOption<string>[];
  handleUpdateLinks: (
    payload: LinkExpirationSettingPayload,
    onSuccessCallback?: () => void,
  ) => void;
  isLoading: boolean;
  links: LinkExpirationSetting[];
  refetch: () => void;
};

export type LinksFieldArray = { [linksArrayName]: LinkExpirationSetting[] };

export type FieldValue = LinkExpirationSetting & {
  id: string;
  index: number;
};

export type ErrorResponse = {
  /** Error type, values of 'Conflict' | ... */
  error: string;
  /** Human readable message for error */
  message: string;
  /** Code used to better debug error messages */
  code: string;
  /** D */
  data: {
    /** List of user emails provided as args to `mutate` */
    args: string[];
  };
};
